import { optionTitle_hoverSurfaceActions } from './HoverSurfaceActionsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let HoverSurfaceActionsOption: LazyOption = createLazyOption(
    {
        key: 'hoverSurfaceActions',
        titleStringKey: optionTitle_hoverSurfaceActions,
        searchTermsStringKey: optionTitle_hoverSurfaceActions,
        allowedOptionKeys: ['MailQuickActions'],
    },
    lazyFullModule,
    m => m.HoverFullSettings
);
export default HoverSurfaceActionsOption;
